// Разметка schema.org. По ней Яндекс и Google собирают расширенные сниппеты:
// путь из хлебных крошек, карточку товара с ценой, контакты организации.
// Все сборщики возвращают готовый объект для useHead({ script: [...] }).

const SITE_NAME = "Smail Dell";

// В JSON-LD внутри <script> опасен только «<»: экранируем, чтобы разметку
// нельзя было закрыть названием товара
export const jsonLdScript = (data) => ({
  type: "application/ld+json",
  innerHTML: JSON.stringify(data).replace(/</g, "\\u003C"),
});

export const organizationLd = (origin) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: origin,
  logo: `${origin}/img/logo_smiledell.svg`,
  description:
    "Мастерская художественного гипса: статуэтки, бюсты и сувениры собственного производства с 1989 года.",
  foundingDate: "1989",
  telephone: "+7 905 286-09-84",
  email: "opt@smaildell.ru",
  address: {
    "@type": "PostalAddress",
    addressCountry: "RU",
    addressLocality: "Санкт-Петербург",
    streetAddress: "Химический переулок, д. 1/9",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+7 905 286-09-84",
    email: "opt@smaildell.ru",
    contactType: "sales",
    areaServed: "RU",
    availableLanguage: "Russian",
  },
});

// Поиск по сайту в выдаче Google
export const websiteLd = (origin) => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: origin,
  inLanguage: "ru-RU",
  potentialAction: {
    "@type": "SearchAction",
    target: `${origin}/catalog?search={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
});

export const breadcrumbsLd = (origin, items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    ...(item.to ? { item: `${origin}${item.to}` } : {}),
  })),
});

// Цену указываем только тогда, когда она видна на странице: разметка не должна
// обещать поисковику больше, чем видит покупатель
export const productLd = ({
  origin,
  url,
  name,
  description,
  images = [],
  vendorCode,
  categoryName,
  price,
  available,
}) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name,
  ...(description ? { description: String(description).slice(0, 600) } : {}),
  ...(images.length ? { image: images } : {}),
  ...(vendorCode ? { sku: String(vendorCode) } : {}),
  ...(categoryName ? { category: categoryName } : {}),
  brand: { "@type": "Brand", name: SITE_NAME },
  ...(price
    ? {
        offers: {
          "@type": "Offer",
          url,
          price: String(price),
          priceCurrency: "RUB",
          itemCondition: "https://schema.org/NewCondition",
          availability: available
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
          seller: { "@type": "Organization", name: SITE_NAME },
        },
      }
    : {}),
});

// Список товаров раздела: поисковику видно, что страница — витрина, а не статья
export const itemListLd = (origin, items) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  numberOfItems: items.length,
  itemListElement: items.slice(0, 60).map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    url: `${origin}${item.url}`,
    name: item.name,
  })),
});
